import React from 'react';
import {Button, Input, Row, Col, message} from 'antd';
import {marginBottom, marginTop} from "../../common/script";
import {sendIntent} from "../api/Api";


export default class AboutUsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            concatInfo: [{
                key: 'weixinName',
                placeholder: 'Username',
                value: '',
                notNull: true,
            }, {
                key: 'mobile',
                placeholder: 'Telephone',
                value: '',
                notNull: true,
            }, {
                key: 'companyName',
                placeholder: 'Company Name',
                value: '',
                notNull: true,
            }, {
                key: 'mail',
                placeholder: 'Email',
                value: ''
            }, {
                key: 'jobTitle',
                placeholder: 'Job Title',
                value: ''
            }, {
                key: 'country',
                placeholder: 'Country',
                value: ''
            },],
            loading: false,//请求
            consultContent: '',//咨询内容
        }
    }


    render() {
        return (<div>
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={'https://qiniu.mrcargo.com/zs_concat_banner.png'} alt={'zs_concat_banner'}
                         className={'width100p'}/>
                    <div className={'width100p first-context font-size64 text-center'} style={marginTop(10)}>
                        <span className={'colorfff'}>Let us give you better service</span>
                    </div>
                </div>
                <Row>
                    <Col span={4} offset={10} style={marginBottom(7)}>
                        <div className={'flex-col width100p'}>
                            {
                                this.state.concatInfo.map((item, index) => {
                                    return <div key={`index${index}`} className={'width100p'}
                                                style={marginTop(index === 0 ? 8 : 4)}>
                                        <div className={`flex-row`}>
                                            <div
                                                className={`${item.notNull ? 'colorED3159 ' : 'colorfff'}`}>{item.notNull ? '*' : ''}</div>
                                            <div
                                                className={'font-size16 #0D182B font-weight400'}>{item.placeholder}</div>
                                        </div>
                                        <Input className={'radius-btn height40 flex1'}
                                               style={marginTop(1)}
                                               disabled={this.state.loading}
                                               value={item.value} onChange={(e) => {
                                            let concatInfo = this.state.concatInfo;
                                            concatInfo[index].value = e.currentTarget.value;
                                            this.setState({
                                                concatInfo: concatInfo
                                            })
                                        }}/>
                                    </div>
                                })
                            }
                            <div className={'width100p'} style={marginTop(4)}>
                                <div className={`flex-row`}>
                                    <div className={'colorED3159 '}>*</div>
                                    <div className={'font-size16 #0D182B font-weight400'}>What’s your needs</div>
                                </div>
                                <Input.TextArea className={'radius-btn'}
                                                value={this.state.consultContent}
                                                autoSize={{minRows: 6, maxRows: 8}} onChange={(e) => {
                                    this.setState({
                                        consultContent: e.currentTarget.value
                                    })
                                }}/>
                            </div>
                            <Button type="primary" shape="default" size={'large'} className={'concat-btn'}
                                    loading={this.state.loading}
                                    disabled={!this.state.concatInfo[0].value || !this.state.concatInfo[1].value || !this.state.concatInfo[2].value || !this.state.consultContent}
                                    style={Object.assign(marginTop(5), {width: 199})} onClick={() => {
                                this.sendIntentForServer();
                            }}>Submit</Button>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    /**
     * 发送意向到客服端
     */
    sendIntentForServer() {
        let params = {};

        for (let item of this.state.concatInfo) {
            params[item.key] = item.value;
        }
        params.consultContent = this.state.consultContent;
        sendIntent(params, () => {
            this.setState({
                loading: true
            })
        }, () => {
            this.setState({
                loading: false
            })
        }).then(res => {
            message.success('Send successfully, waiting for contact');
        })
    }
}


